module.exports = __webpack_public_path__ + "static/media/EricSolheim.b1e604e2.svg";